<template>
  <div class="tmp-unificar">
    <div v-if="validatingToken" class="tmp-unificar__center">
      <v-progress-circular indeterminate color="#943634" size="56" />
      <p class="mt-4 mb-0">Validando sessao...</p>
    </div>

    <div v-else-if="!usuarioLogado" class="tmp-unificar__login">
      <login :sessaoExpirada="sessaoExpirada" />
    </div>

    <div v-else-if="!isAdmin" class="tmp-unificar__center">
      <v-icon size="56" color="#943634">mdi-shield-alert</v-icon>
      <h1 class="text-h5 mt-4">Acesso restrito</h1>
      <p>Esta ferramenta temporaria exige usuario administrador.</p>
    </div>

    <div v-else-if="!senhaLiberada" class="tmp-unificar__center">
      <div class="tmp-unificar__gate">
        <v-icon size="48" color="#943634">mdi-database-lock</v-icon>
        <h1 class="text-h5 mt-4 mb-2">Unificacao temporaria de clones</h1>
        <p class="tmp-unificar__muted">
          Digite a senha temporaria para carregar os candidatos.
        </p>
        <v-text-field
          v-model="senha"
          type="password"
          label="Senha"
          outlined
          dense
          autocomplete="off"
          @keyup.enter="desbloquear"
        />
        <v-btn color="#943634" dark block @click="desbloquear">
          <v-icon left>mdi-lock-open</v-icon>
          Acessar
        </v-btn>
      </div>
    </div>

    <template v-else>
      <header class="tmp-unificar__header">
        <div>
          <h1>Unificacao de Produtos Clones</h1>
          <p>
            Ferramenta temporaria. A analise agrupa produtos globalmente; os pregoes relacionados ficam como detalhe.
          </p>
        </div>
        <div class="tmp-unificar__header-actions">
          <v-chip color="#943634" text-color="white" label>
            <v-icon left small>mdi-account-shield</v-icon>
            {{ dadosUser.name || dadosUser.email }}
          </v-chip>
          <v-btn outlined color="#943634" @click="logout">
            <v-icon left>mdi-logout</v-icon>
            Sair
          </v-btn>
        </div>
      </header>

      <section class="tmp-unificar__filters">
        <v-select
          v-model="modo"
          :items="modos"
          item-text="text"
          item-value="value"
          label="Modo de comparacao"
          outlined
          dense
          hide-details
          class="tmp-unificar__filter"
        />

        <div class="tmp-unificar__slider">
          <label>Similaridade minima do fallback: <strong>{{ similaridade }}%</strong></label>
          <v-slider
            v-model="similaridade"
            min="30"
            max="100"
            step="1"
            color="#943634"
            hide-details
          />
        </div>

        <v-switch
          v-model="arquivados"
          label="Incluir arquivados"
          color="#943634"
          hide-details
          class="mt-0"
        />

        <v-switch
          v-model="smart"
          label="Anti-ruido"
          color="#943634"
          hide-details
          class="mt-0"
          :disabled="modo !== 'prefix'"
        />

        <v-btn color="#943634" dark :loading="loading" @click="carregarCandidatos">
          <v-icon left>mdi-refresh</v-icon>
          Atualizar
        </v-btn>
      </section>

      <section class="tmp-unificar__stats">
        <div>
          <strong>{{ stats.produtosAnalisados || 0 }}</strong>
          <span>Produtos analisados</span>
        </div>
        <div>
          <strong>{{ stats.totalGrupos || 0 }}</strong>
          <span>Grupos suspeitos</span>
        </div>
        <div>
          <strong>{{ stats.totalProdutosClones || 0 }}</strong>
          <span>Produtos clones sugeridos</span>
        </div>
        <div>
          <strong>{{ formatarData(geradoEm) }}</strong>
          <span>Ultima leitura</span>
        </div>
      </section>

      <v-alert
        v-if="erroCarregamento"
        type="error"
        dense
        outlined
        class="mx-6"
      >
        {{ erroCarregamento }}
      </v-alert>

      <main class="tmp-unificar__content">
        <div v-if="loading" class="tmp-unificar__center tmp-unificar__center--inline">
          <v-progress-circular indeterminate color="#943634" size="44" />
          <p class="mt-3 mb-0">Carregando candidatos...</p>
        </div>

        <v-alert v-else-if="!grupos.length" type="success" outlined>
          Nenhum grupo suspeito encontrado com os filtros atuais.
        </v-alert>

        <v-card
          v-for="grupo in grupos"
          :key="grupo.id"
          class="tmp-unificar__group"
          outlined
        >
          <div class="tmp-unificar__group-header">
            <div>
              <h2>{{ grupo.survivor.name }}</h2>
              <span>
                Grupo global de produto | Canonico: {{ grupo.nomeCanonico || grupo.survivor.nomeCanonico }}
              </span>
              <div class="tmp-unificar__impact-row">
                <v-chip small color="#fdecec" text-color="#943634" label>
                  {{ totalPregoesComClones(grupo) }} pregao(oes) com clone(s)
                </v-chip>
                <v-chip small color="#eeeeee" text-color="#555" label>
                  {{ totalPregoesRelacionados(grupo) }} pregao(oes) relacionados no total
                </v-chip>
                <v-chip small color="#eeeeee" text-color="#555" label>
                  {{ totalItensClones(grupo) }} item(ns) de clone
                </v-chip>
              </div>
            </div>
            <v-btn
              color="#943634"
              dark
              :loading="previewing"
              :disabled="totalClonesSelecionados === 0"
              @click="abrirPreviewGlobal"
            >
              <v-icon left>mdi-eye-check</v-icon>
              Revisar selecionados ({{ totalClonesSelecionados }})
            </v-btn>
          </div>

          <div class="tmp-unificar__survivor">
            <div class="tmp-unificar__badge tmp-unificar__badge--survivor">Sobrevivente</div>
            <div class="tmp-unificar__product">
              <img :src="grupo.survivor.imageUrl" alt="" @error="ocultarImagemQuebrada" />
              <div>
                <strong>#{{ grupo.survivor.id }} - {{ grupo.survivor.name }}</strong>
                <span>
                  Uso global: {{ grupo.survivor.usoGlobal.totalItens }} item(ns) em
                  {{ grupo.survivor.usoGlobal.totalPregoes }} pregao(oes)
                </span>
                <small>{{ formatarItens(grupo.survivor.itens) }}</small>
              </div>
            </div>
          </div>

          <div class="tmp-unificar__clones">
            <div
              v-for="clone in grupo.clones"
              :key="clone.id"
              class="tmp-unificar__clone"
              :class="{ 'tmp-unificar__clone--selected': cloneSelecionado(grupo, clone) }"
            >
              <v-checkbox
                :input-value="cloneSelecionado(grupo, clone)"
                color="#943634"
                hide-details
                class="tmp-unificar__checkbox"
                @change="valor => alternarClone(grupo, clone, valor)"
              />
              <div class="tmp-unificar__badge">Clone</div>
              <div class="tmp-unificar__product">
                <img :src="clone.imageUrl" alt="" @error="ocultarImagemQuebrada" />
                <div>
                  <strong>#{{ clone.id }} - {{ clone.name }}</strong>
                  <span>
                    Match {{ clone.similarity }}% | Uso global:
                    {{ clone.usoGlobal.totalItens }} item(ns) em {{ clone.usoGlobal.totalPregoes }} pregao(oes)
                  </span>
                  <small>{{ formatarItens(clone.itens) }}</small>
                </div>
              </div>
            </div>
          </div>

          <v-expansion-panels
            v-if="grupo.pregoesRelacionados && grupo.pregoesRelacionados.length"
            flat
            class="tmp-unificar__pregoes"
          >
            <v-expansion-panel>
              <v-expansion-panel-header>
                Detalhes dos pregoes: {{ totalPregoesComClones(grupo) }} com clone(s),
                {{ totalPregoesRelacionados(grupo) }} relacionados no total
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-simple-table dense>
                  <thead>
                    <tr>
                      <th>Pregao</th>
                      <th>Orgao</th>
                      <th>Status</th>
                      <th>Produtos/itens no pregao</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="pregao in grupo.pregoesRelacionados" :key="pregao.id">
                      <td>{{ pregao.idPregao || ("#" + pregao.id) }}</td>
                      <td>{{ pregao.nomeOrgao }}</td>
                      <td>{{ pregao.arquivado ? "Arquivado" : "Ativo" }}</td>
                      <td>{{ formatarProdutosPregao(pregao.produtos) }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card>
      </main>

      <v-dialog v-model="dialogPreview" max-width="920" persistent>
        <v-card v-if="previewsAtuais.length">
          <v-card-title class="tmp-unificar__dialog-title">
            Revisar unificacao global
          </v-card-title>
          <v-card-text>
            <v-alert type="warning" dense outlined>
              Esta acao executa {{ totaisPreview.operacoes }} unificacao(oes) e altera todos os itens de pregao
              que usam os clones abaixo para seus respectivos produtos sobreviventes.
            </v-alert>

            <div class="tmp-unificar__preview-survivor">
              <strong>Unificacoes nesta confirmacao:</strong>
              <ul class="tmp-unificar__preview-survivor-list">
                <li v-for="preview in previewsAtuais" :key="preview.grupoId">
                  Sobrevivente #{{ preview.survivor.id }} - {{ preview.survivor.name }}
                  ({{ preview.totais.clones }} clone(s))
                </li>
              </ul>
            </div>

            <div class="tmp-unificar__preview-impact">
              <div>
                <strong>{{ totaisPreview.itens }}</strong>
                <span>Itens de clone que serao remapeados</span>
              </div>
              <div>
                <strong>{{ totaisPreview.pregoes }}</strong>
                <span>Pregoes distintos afetados</span>
              </div>
              <div>
                <strong>{{ totaisPreview.clones }}</strong>
                <span>Produtos clones selecionados</span>
              </div>
              <div>
                <strong>{{ totaisPreview.operacoes }}</strong>
                <span>Sobreviventes envolvidos</span>
              </div>
            </div>

            <v-simple-table dense>
              <thead>
                <tr>
                  <th>Clone</th>
                  <th class="text-right">Itens afetados</th>
                  <th class="text-right">Pregoes afetados</th>
                  <th>Exemplos de pregoes</th>
                </tr>
              </thead>
              <tbody v-for="preview in previewsAtuais" :key="preview.grupoId">
                <tr class="tmp-unificar__preview-group-row">
                  <td colspan="4">
                    Sobrevivente #{{ preview.survivor.id }} - {{ preview.survivor.name }}
                  </td>
                </tr>
                <tr v-for="impacto in preview.impactos" :key="impacto.clone.id">
                  <td>#{{ impacto.clone.id }} - {{ impacto.clone.name }}</td>
                  <td class="text-right">{{ impacto.totalItens }}</td>
                  <td class="text-right">{{ impacto.totalPregoes }}</td>
                  <td>{{ formatarPregoes(impacto.pregoesAfetados) }}</td>
                </tr>
              </tbody>
            </v-simple-table>

            <v-text-field
              v-model="confirmacao"
              label="Digite UNIFICAR para confirmar"
              outlined
              dense
              class="mt-5"
              autocomplete="off"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn text :disabled="executing" @click="fecharPreview">Cancelar</v-btn>
            <v-btn
              color="#943634"
              dark
              :loading="executing"
              :disabled="confirmacao !== 'UNIFICAR'"
              @click="executarUnificacao"
            >
              <v-icon left>mdi-database-sync</v-icon>
              Executar unificacao
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogResultado" max-width="820">
        <v-card v-if="resultadoExecucao">
          <v-card-title class="tmp-unificar__dialog-title">
            Resultado da unificacao
          </v-card-title>
          <v-card-text>
            <v-alert type="success" dense outlined>
              {{ resultadoExecucao.totais.itensRemapeados }} item(ns) remapeado(s).
              {{ resultadoExecucao.totais.produtosExcluidos }} produto(s) clone excluido(s).
              {{ resultadoExecucao.totais.operacoes }} unificacao(oes) processada(s).
            </v-alert>
            <v-simple-table dense>
              <thead>
                <tr>
                  <th>Clone</th>
                  <th class="text-right">Itens remapeados</th>
                  <th>Produto clone</th>
                </tr>
              </thead>
              <tbody v-for="operacao in resultadoExecucao.operacoes" :key="operacao.survivor.id">
                <tr class="tmp-unificar__preview-group-row">
                  <td colspan="3">
                    Sobrevivente #{{ operacao.survivor.id }} - {{ operacao.survivor.name }}
                  </td>
                </tr>
                <tr v-for="execucao in operacao.execucoes" :key="execucao.clone.id">
                  <td>#{{ execucao.clone.id }} - {{ execucao.clone.name }}</td>
                  <td class="text-right">{{ execucao.itensRemapeados }}</td>
                  <td>
                    <span v-if="execucao.produtoExcluido">Excluido</span>
                    <span v-else>Mantido: {{ execucao.motivoProdutoMantido }}</span>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="#943634" dark @click="dialogResultado = false">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>

<script>
import axios from "axios";
import login from "./usuario/login";
import { showError, urlApi, userKey } from "@/global";

export default {
  name: "tmpUnificarClones",
  components: { login },
  props: {
    validatingToken: { type: Boolean, default: false },
    usuarioLogado: { type: Boolean, default: false },
    sessaoExpirada: { type: Boolean, default: false },
    dadosUser: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      senha: "",
      senhaLiberada: false,
      modo: "prefix",
      similaridade: 75,
      arquivados: true,
      smart: true,
      loading: false,
      previewing: false,
      executing: false,
      erroCarregamento: "",
      geradoEm: null,
      stats: {},
      grupos: [],
      selecionados: {},
      previewsAtuais: [],
      confirmacao: "",
      dialogPreview: false,
      dialogResultado: false,
      resultadoExecucao: null,
      modos: [
        { text: "Sufixo de clone + prefixo", value: "prefix" },
        { text: "Similaridade global", value: "global" },
      ],
    };
  },
  computed: {
    isAdmin() {
      return !!(this.dadosUser && this.dadosUser.admin);
    },

    gruposSelecionados() {
      return this.grupos.filter(grupo => this.grupoSelecionado(grupo).length > 0);
    },

    totalClonesSelecionados() {
      return Object.keys(this.selecionados).reduce((acc, grupoId) => {
        const cloneIds = this.selecionados[grupoId];
        return acc + (Array.isArray(cloneIds) ? cloneIds.length : 0);
      }, 0);
    },

    totaisPreview() {
      const pregoes = new Set();
      const totais = this.previewsAtuais.reduce((acc, preview) => {
        const previewTotais = preview.totais || {};
        acc.itens += Number(previewTotais.itens) || 0;
        acc.clones += Number(previewTotais.clones) || 0;

        (preview.impactos || []).forEach(impacto => {
          (impacto.pregoesAfetados || []).forEach(pregao => pregoes.add(Number(pregao.id)));
        });

        return acc;
      }, { itens: 0, clones: 0 });

      return {
        itens: totais.itens,
        clones: totais.clones,
        pregoes: pregoes.size,
        operacoes: this.previewsAtuais.length,
      };
    },
  },
  watch: {
    modo(valor) {
      if (valor !== "prefix") {
        this.smart = false;
      } else {
        this.smart = true;
      }
    },
  },
  methods: {
    desbloquear() {
      if (this.senha !== "unificar") {
        showError("Senha temporaria invalida.");
        return;
      }
      this.senhaLiberada = true;
      this.carregarCandidatos();
    },

    async carregarCandidatos() {
      this.loading = true;
      this.erroCarregamento = "";

      try {
        const res = await axios.get(`${urlApi}/tmp-unificar-clones/candidatos`, {
          params: {
            modo: this.modo,
            similaridade: this.similaridade,
            arquivados: this.arquivados,
            smart: this.smart,
          },
          headers: {
            "x-tmp-unificar-clones-senha": this.senha,
          },
        });

        this.geradoEm = res.data.geradoEm;
        this.stats = res.data.stats || {};
        this.grupos = res.data.grupos || [];
        this.selecionados = {};
      } catch (err) {
        this.erroCarregamento = this.extrairMensagemErro(err);
        showError(err);
      } finally {
        this.loading = false;
      }
    },

    extrairMensagemErro(err) {
      if (err && err.response && err.response.data) {
        return err.response.data.error || err.response.data.message || String(err.response.data);
      }
      return err && err.message ? err.message : "Falha ao carregar dados.";
    },

    grupoSelecionado(grupo) {
      return this.selecionados[grupo.id] || [];
    },

    cloneSelecionado(grupo, clone) {
      return this.grupoSelecionado(grupo).includes(Number(clone.id));
    },

    alternarClone(grupo, clone, selecionado) {
      const atuais = [...this.grupoSelecionado(grupo)];
      const cloneId = Number(clone.id);
      const novoValor = selecionado
        ? Array.from(new Set([...atuais, cloneId]))
        : atuais.filter(id => id !== cloneId);

      this.$set(this.selecionados, grupo.id, novoValor);
    },

    async abrirPreviewGlobal() {
      const gruposSelecionados = this.gruposSelecionados;
      if (!gruposSelecionados.length) return;

      this.confirmacao = "";
      this.previewsAtuais = [];
      this.previewing = true;

      try {
        const previews = [];

        for (const grupo of gruposSelecionados) {
          const cloneProdutoIds = this.grupoSelecionado(grupo);
          const res = await axios.post(`${urlApi}/tmp-unificar-clones/preview`, {
            senha: this.senha,
            survivorProdutoId: grupo.survivor.id,
            cloneProdutoIds,
          });

          previews.push({
            grupoId: grupo.id,
            cloneProdutoIds,
            survivor: res.data.survivor,
            impactos: res.data.impactos || [],
            totais: res.data.totais || { clones: 0, itens: 0, pregoes: 0 },
          });
        }

        this.previewsAtuais = previews;
        this.dialogPreview = true;
      } catch (err) {
        showError(err);
      } finally {
        this.previewing = false;
      }
    },

    fecharPreview() {
      if (this.executing) return;
      this.dialogPreview = false;
      this.previewsAtuais = [];
      this.confirmacao = "";
    },

    async executarUnificacao() {
      if (!this.previewsAtuais.length || this.confirmacao !== "UNIFICAR") return;

      this.executing = true;
      try {
        const operacoes = this.previewsAtuais.map(preview => ({
          survivorProdutoId: preview.survivor.id,
          cloneProdutoIds: preview.cloneProdutoIds,
        }));

        const res = await axios.post(`${urlApi}/tmp-unificar-clones/executar-lote`, {
          senha: this.senha,
          confirmacao: this.confirmacao,
          operacoes,
        });

        this.resultadoExecucao = res.data;
        this.dialogPreview = false;
        this.dialogResultado = true;
        this.$toasted.global.defaultSuccess({ msg: "Unificacao executada com sucesso." });
        await this.carregarCandidatos();
      } catch (err) {
        showError(err);
      } finally {
        this.executing = false;
      }
    },

    formatarItens(itens) {
      const lista = (itens || []).slice(0, 4).map(item => {
        const pregao = item.pregao ? `${item.pregao.idPregao || ("#" + item.pregao.id)} / ` : "";
        return `${pregao}Item ${item.numeroItem || item.id}`;
      });
      const restante = (itens || []).length - lista.length;
      return restante > 0 ? `${lista.join(", ")} + ${restante} outro(s)` : lista.join(", ");
    },

    formatarProdutosPregao(produtos) {
      return (produtos || []).map(produto => {
        const itens = (produto.itens || [])
          .map(item => `Item ${item.numeroItem || item.id}`)
          .join(", ");
        return `#${produto.id} ${produto.name}${itens ? ` (${itens})` : ""}`;
      }).join(" | ");
    },

    totalPregoesComClones(grupo) {
      return grupo && grupo.resumoImpacto
        ? grupo.resumoImpacto.totalPregoesComClones || 0
        : (grupo.pregoesComClones || []).length;
    },

    totalPregoesRelacionados(grupo) {
      return grupo && grupo.resumoImpacto
        ? grupo.resumoImpacto.totalPregoesRelacionados || 0
        : (grupo.pregoesRelacionados || []).length;
    },

    totalItensClones(grupo) {
      return grupo && grupo.resumoImpacto
        ? grupo.resumoImpacto.totalItensClones || 0
        : (grupo.clones || []).reduce((acc, clone) => acc + (clone.usoGlobal.totalItens || 0), 0);
    },

    formatarPregoes(pregoes) {
      const lista = (pregoes || []).slice(0, 3).map(pregao => pregao.idPregao || `#${pregao.id}`);
      const restante = (pregoes || []).length - lista.length;
      return restante > 0 ? `${lista.join(", ")} + ${restante} outro(s)` : lista.join(", ");
    },

    formatarData(data) {
      if (!data) return "-";
      return new Date(data).toLocaleString("pt-BR");
    },

    ocultarImagemQuebrada(event) {
      event.target.style.display = "none";
    },

    logout() {
      localStorage.removeItem(userKey);
      window.location.reload();
    },
  },
};
</script>

<style scoped>
.tmp-unificar {
  min-height: 100vh;
  background: #f5f5f5;
  color: #333;
  overflow-y: auto;
}

.tmp-unificar__center,
.tmp-unificar__login {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.tmp-unificar__center--inline {
  min-height: 240px;
}

.tmp-unificar__login {
  background: #943634;
}

.tmp-unificar__gate {
  width: 100%;
  max-width: 420px;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 28px;
  text-align: center;
}

.tmp-unificar__muted {
  color: #666;
  font-weight: 400;
}

.tmp-unificar__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 24px 32px;
  background: #fff;
  border-bottom: 1px solid #dedede;
}

.tmp-unificar__header h1 {
  margin: 0;
  font-size: 24px;
  line-height: 1.2;
  font-weight: 700;
}

.tmp-unificar__header p {
  margin: 6px 0 0;
  color: #666;
  font-weight: 400;
}

.tmp-unificar__header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.tmp-unificar__filters {
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 16px 32px;
  background: #fff;
  border-bottom: 1px solid #dedede;
  flex-wrap: wrap;
}

.tmp-unificar__filter {
  max-width: 260px;
}

.tmp-unificar__slider {
  flex: 1 1 260px;
  min-width: 240px;
  max-width: 420px;
}

.tmp-unificar__slider label {
  display: block;
  font-size: 13px;
  color: #555;
  margin-bottom: 2px;
}

.tmp-unificar__stats {
  display: grid;
  grid-template-columns: repeat(4, minmax(160px, 1fr));
  gap: 12px;
  padding: 18px 32px;
}

.tmp-unificar__stats > div {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 14px 16px;
}

.tmp-unificar__stats strong {
  display: block;
  font-size: 22px;
  line-height: 1.2;
  color: #943634;
}

.tmp-unificar__stats span {
  display: block;
  color: #666;
  font-size: 13px;
  margin-top: 4px;
}

.tmp-unificar__content {
  padding: 0 32px 32px;
}

.tmp-unificar__group {
  margin-bottom: 16px;
  overflow: hidden;
}

.tmp-unificar__group-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px;
  background: #fafafa;
  border-bottom: 1px solid #e0e0e0;
}

.tmp-unificar__group-header h2 {
  margin: 0;
  font-size: 18px;
  line-height: 1.25;
}

.tmp-unificar__group-header span {
  color: #666;
  font-size: 13px;
}

.tmp-unificar__impact-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}

.tmp-unificar__survivor,
.tmp-unificar__clone {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
}

.tmp-unificar__survivor {
  background: #eef8ef;
  border-bottom: 1px solid #d8ead9;
}

.tmp-unificar__clones {
  display: flex;
  flex-direction: column;
}

.tmp-unificar__pregoes {
  border-top: 1px solid #eeeeee;
}

.tmp-unificar__pregoes .v-expansion-panel::before {
  box-shadow: none;
}

.tmp-unificar__pregoes td,
.tmp-unificar__pregoes th {
  vertical-align: top;
}

.tmp-unificar__clone {
  border-bottom: 1px solid #eeeeee;
  background: #fff;
}

.tmp-unificar__clone:last-child {
  border-bottom: 0;
}

.tmp-unificar__clone--selected {
  background: #fff8f2;
}

.tmp-unificar__checkbox {
  flex: 0 0 auto;
  margin-top: 0;
  padding-top: 0;
}

.tmp-unificar__badge {
  flex: 0 0 auto;
  width: 102px;
  text-align: center;
  border-radius: 999px;
  padding: 5px 10px;
  font-size: 12px;
  font-weight: 700;
  color: #943634;
  background: #fdecec;
  border: 1px solid #f2c7c7;
}

.tmp-unificar__badge--survivor {
  color: #1d6b2a;
  background: #dcf4df;
  border-color: #bde7c2;
}

.tmp-unificar__product {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.tmp-unificar__product img {
  flex: 0 0 44px;
  width: 44px;
  height: 44px;
  object-fit: cover;
  border-radius: 6px;
  background: #ededed;
}

.tmp-unificar__product strong,
.tmp-unificar__product span,
.tmp-unificar__product small {
  display: block;
  overflow-wrap: anywhere;
}

.tmp-unificar__product strong {
  font-size: 15px;
  line-height: 1.3;
}

.tmp-unificar__product span {
  margin-top: 3px;
  color: #555;
  font-size: 13px;
  font-weight: 400;
}

.tmp-unificar__product small {
  margin-top: 2px;
  color: #777;
  font-size: 12px;
}

.tmp-unificar__dialog-title {
  color: #943634;
}

.tmp-unificar__preview-survivor {
  margin: 12px 0 16px;
  padding: 12px;
  background: #eef8ef;
  border: 1px solid #d8ead9;
  border-radius: 8px;
}

.tmp-unificar__preview-survivor-list {
  margin: 8px 0 0;
  padding-left: 18px;
}

.tmp-unificar__preview-impact {
  display: grid;
  grid-template-columns: repeat(4, minmax(130px, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}

.tmp-unificar__preview-impact > div {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 12px;
  background: #fafafa;
}

.tmp-unificar__preview-impact strong,
.tmp-unificar__preview-impact span {
  display: block;
}

.tmp-unificar__preview-impact strong {
  color: #943634;
  font-size: 22px;
  line-height: 1.1;
}

.tmp-unificar__preview-impact span {
  margin-top: 4px;
  color: #666;
  font-size: 13px;
}

.tmp-unificar__preview-group-row td {
  background: #fafafa;
  color: #943634;
  font-weight: 700;
}

@media (max-width: 900px) {
  .tmp-unificar__header,
  .tmp-unificar__group-header {
    align-items: stretch;
    flex-direction: column;
  }

  .tmp-unificar__stats {
    grid-template-columns: repeat(2, minmax(140px, 1fr));
  }
}

@media (max-width: 640px) {
  .tmp-unificar__header,
  .tmp-unificar__filters,
  .tmp-unificar__stats,
  .tmp-unificar__content {
    padding-left: 16px;
    padding-right: 16px;
  }

  .tmp-unificar__stats {
    grid-template-columns: 1fr;
  }

  .tmp-unificar__preview-impact {
    grid-template-columns: 1fr;
  }

  .tmp-unificar__survivor,
  .tmp-unificar__clone {
    align-items: flex-start;
    flex-wrap: wrap;
  }

  .tmp-unificar__badge {
    width: auto;
  }
}
</style>
